export const GET_ITEMS_COUNT = 'GET_ITEMS_COUNT';
export const GET_ITEMS_COUNT_SUCCESS = 'GET_ITEMS_COUNT_SUCCESS';
export const GET_ITEMS_COUNT_FAILURE = 'GET_ITEMS_COUNT_FAILURE';

export const GET_STORES_COUNT = 'GET_STORES_COUNT';
export const GET_STORES_COUNT_SUCCESS = 'GET_STORES_COUNT_SUCCESS';
export const GET_STORES_COUNT_FAILURE = 'GET_STORES_COUNT_FAILURE';

export const GET_USERS_COUNT = 'GET_USERS_COUNT';
export const GET_USERS_COUNT_SUCCESS = 'GET_USERS_COUNT_SUCCESS';
export const GET_USERS_COUNT_FAILURE = 'GET_USERS_COUNT_FAILURE';

export const GET_DOCUMENTS_COUNT = 'GET_DOCUMENTS_COUNT';
export const GET_DOCUMENTS_COUNT_SUCCESS = 'GET_DOCUMENTS_COUNT_SUCCESS';
export const GET_DOCUMENTS_COUNT_FAILURE = 'GET_DOCUMENTS_COUNT_FAILURE';

export const GET_COMPANIES_COUNT = 'GET_COMPANIES_COUNT';
export const GET_COMPANIES_COUNT_SUCCESS = 'GET_COMPANIES_COUNT_SUCCESS';
export const GET_COMPANIES_COUNT_FAILURE = 'GET_COMPANIES_COUNT_FAILURE';

export const GET_ITEMS_SALES_SUMMARY = 'GET_ITEMS_SALES_SUMMARY';
export const GET_ITEMS_SALES_SUMMARY_SUCCESS = 'GET_ITEMS_SALES_SUMMARY_SUCCESS';
export const GET_ITEMS_SALES_SUMMARY_FAILURE = 'GET_ITEMS_SALES_SUMMARY_FAILURE';

export const GET_INVOICE_SUMMARY = 'GET_INVOICE_SUMMARY';
export const GET_INVOICE_SUMMARY_SUCCESS = 'GET_INVOICE_SUMMARY_SUCCESS';
export const GET_INVOICE_SUMMARY_FAILURE = 'GET_INVOICE_SUMMARY_FAILURE';

export const PREDICT_NEXT_VALUE = 'PREDICT_NEXT_VALUE';
export const PREDICT_NEXT_VALUE_SUCCESS = 'PREDICT_NEXT_VALUE_SUCCESS';
export const PREDICT_NEXT_VALUE_FAILURE = 'PREDICT_NEXT_VALUE_FAILURE';

export const GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION = 'GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION';
export const GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_SUCCESS = 'GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_SUCCESS';
export const GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_FAILURE = 'GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_FAILURE';

export const PREDICT_SALES = 'PREDICT_SALES';
export const PREDICT_SALES_SUCCESS = 'PREDICT_SALES_SUCCESS';
export const PREDICT_SALES_FAILURE = 'PREDICT_SALES_FAILURE';

export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const GET_DASHBOARD_DATA_SUCCESS = 'GET_DASHBOARD_DATA_SUCCESS';
export const GET_DASHBOARD_DATA_FAILURE = 'GET_DASHBOARD_DATA_FAILURE';

export const GET_STORE_WISE_ITEMS = 'GET_STORE_WISE_ITEMS';
export const GET_STORE_WISE_ITEMS_SUCCESS = 'GET_STORE_WISE_ITEMS_SUCCESS';
export const GET_STORE_WISE_ITEMS_FAILURE = 'GET_STORE_WISE_ITEMS_FAILURE';

export const GET_CATEGORY_WISE_ITEMS = 'GET_CATEGORY_WISE_ITEMS';
export const GET_CATEGORY_WISE_ITEMS_SUCCESS = 'GET_CATEGORY_WISE_ITEMS_SUCCESS';
export const GET_CATEGORY_WISE_ITEMS_FAILURE = 'GET_CATEGORY_WISE_ITEMS_FAILURE';

export const FAST_MOVING_SLOW_MOVING_ITEMS = 'FAST_MOVING_SLOW_MOVING_ITEMS';
export const FAST_MOVING_SLOW_MOVING_ITEMS_SUCCESS = 'FAST_MOVING_SLOW_MOVING_ITEMS_SUCCESS';
export const FAST_MOVING_SLOW_MOVING_ITEMS_FAILURE = 'FAST_MOVING_SLOW_MOVING_ITEMS_FAILURE';

export const STOCK_LEVEL_ANALYSIS = 'STOCK_LEVEL_ANALYSIS';
export const STOCK_LEVEL_ANALYSIS_SUCCESS = 'STOCK_LEVEL_ANALYSIS_SUCCESS';
export const STOCK_LEVEL_ANALYSIS_FAILURE = 'STOCK_LEVEL_ANALYSIS_FAILURE';

export const STOCK_AGEING = 'STOCK_AGEING';
export const STOCK_AGEING_SUCCESS = 'STOCK_AGEING_SUCCESS';
export const STOCK_AGEING_FAILURE = 'STOCK_AGEING_FAILURE';

export const ON_TIME_DELAY_PRODUCTION = 'ON_TIME_DELAY_PRODUCTION';
export const ON_TIME_DELAY_PRODUCTION_SUCCESS = 'ON_TIME_DELAY_PRODUCTION_SUCCESS';
export const ON_TIME_DELAY_PRODUCTION_FAILURE = 'ON_TIME_DELAY_PRODUCTION_FAILURE';

export const WORK_ORDER_STATUS = 'WORK_ORDER_STATUS';
export const WORK_ORDER_STATUS_SUCCESS = 'WORK_ORDER_STATUS_SUCCESS';
export const WORK_ORDER_STATUS_FAILURE = 'WORK_ORDER_STATUS_FAILURE';

export const GET_SALES_DASHBOARD_DETAILS = 'GET_SALES_DASHBOARD_DETAILS';
export const GET_SALES_DASHBOARD_DETAILS_SUCCESS = 'GET_SALES_DASHBOARD_DETAILS_SUCCESS';
export const GET_SALES_DASHBOARD_DETAILS_FAILURE = 'GET_SALES_DASHBOARD_DETAILS_FAILURE';